import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { StateProvider } from './services/context/ContextProvider';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <StateProvider>
        <Router>
          <App />
        </Router>
      </StateProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
